import { gql } from '@apollo/client/core';

export const MARK_LINE_ITEMS_AS_GENERATED_BY_POS = gql`
  mutation markLineItemsAsGeneratedByPos($orgUuid: String!, $orderUuid: String!) {
    markLineItemsAsGeneratedByPos(orgUUID: $orgUuid, orderUUID: $orderUuid)
  }
`;
